import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P115List_1({ dataTable }) {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="recSeq" header="ลำดับที่" body={(e) => normalColumn(e, "recSeq", "ลำดับที่")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="recName" header="ชื่อ-นามสกุล" body={(e) => normalColumn(e, "recName", "ชื่อ-นามสกุล")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="recTitle" header="ตำแหน่ง" body={(e) => normalColumn(e, "recTitle", "ตำแหน่ง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
